import { spacing } from 'styles/constants';

export const ORDER_CONTAINERS_SECTION_SPACING = spacing.$8;

export const geographicalFeeLabelIdMap = { CO: 'geographicalFeeCO' };
